const messages = {
  subtitle: "Meet Our Bridgestone team",
  title: "Contact service",
  description: "Welcome to contact service",
  teams: {
    direct: "Direct",
    indirect: "In Direct",
    tyre: "Zespół handlu oponami",
    car: "Zespół salonów samochodowych",
    lkw: "Zespół ciężarówek",
    em_otr: "Zespół EM/OTR",
    farm_tractor: "Zespół ciągników rolniczych",
    bandag: "Zespół Bandag",
    subtitle: "Meet Our Bridgestone team",
  },
  contact: {
    index: {
      title: "",
      description: "",
    },
    categories: {
      service: {
        description: "",
      },
      touch: {
        title: "",
        description: "",
      },
      contact: {
        short_desc: "",
      },
    },
    strategicPartners: {
      cardTitle: "",
      short_desc: "",
    },
  },
};

export default {
  messages,
};
